// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-modal-class .disabled-title {\n  display: flex;\n  align-items: center;\n}\n.file-modal-class .disabled-title .line-text {\n  padding-left: 10px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.file-modal-class .file-template {\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
